// The Auto Registration cell: which registry registers the TLD, saved as soon as it is chosen.
// Read-only for anyone but superadmin and finance.
import type { Registry, TldPricing } from "@kilat/contracts/tld-pricing";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { m } from "@/lib/paraglide/messages.js";
import { pricingError } from "../pricing-error";
import { REGISTRY_LABELS, registryItems } from "../registries";
import { useSetTldRegistry } from "./mutation";

export function TldRegistrySelect({ tld, editable }: { tld: TldPricing; editable: boolean }) {
  const choose = useSetTldRegistry(tld.id);
  const items = registryItems();
  const name = `.${tld.tld}`;

  function change(registry: Registry | null) {
    if (!registry || registry === tld.registry) return;
    choose.mutate(registry, {
      onSuccess: () =>
        toast.success(m.tld_pricing_registry_saved({ tld: name, registry: REGISTRY_LABELS[registry]() })),
      onError: (error) => toast.error(pricingError(error)),
    });
  }

  return (
    <Select items={items} value={tld.registry} onValueChange={change}>
      <SelectTrigger aria-label={m.tld_pricing_registry_label({ tld: name })} disabled={!editable || choose.isPending}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {items.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
